export const navLinks = [
  { id: "address", label: "最新地址" },
  { id: "domain", label: "防走失" },
  { id: "download", label: "App下载" },
  { id: "channels", label: "内容频道" },
  { id: "guide", label: "使用教程" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { value: "多线路", label: "官网入口互为备份" },
  { value: "每日巡检", label: "地址状态及时更新" },
  { value: "全平台", label: "安卓 / iOS / 电脑" },
  { value: "收藏即达", label: "本页长期有效" },
];

export const addressLines = [
  {
    name: "官网主线路",
    desc: "官方发布页入口，优先使用，页面稳定、更新最快。",
    status: "推荐",
    statusType: "primary",
  },
  {
    name: "备用线路 A",
    desc: "主线路访问缓慢或打不开时可切换使用，与主线内容一致。",
    status: "可用",
    statusType: "accent",
  },
  {
    name: "备用线路 B",
    desc: "移动网络环境下表现更好，适合流量访问的用户。",
    status: "可用",
    statusType: "accent",
  },
];

export const domainSteps = [
  {
    icon: "ri-refresh-line",
    title: "先刷新再判断",
    desc: "网址偶尔打不开只是 DNS 缓存或网络抖动。先强制刷新页面、重启浏览器，多数情况即可恢复。",
  },
  {
    icon: "ri-wifi-line",
    title: "切换网络环境",
    desc: "同一地址在移动数据下可能可用。Wi-Fi 打不开时，先用手机流量再试一次，排除本地网络问题。",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "回到本页核对地址",
    desc: "旧地址失效时，回到本页获取当下可用入口。收藏本页即可随时找回，不必到处搜索。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "保存防走失方式",
    desc: "把本页加入书签、发送到自己的邮箱或聊天窗口，多留一份记忆，避免彻底走失。",
  },
];

export const downloadTabs = [
  {
    key: "android",
    label: "安卓 Android",
    icon: "ri-android-line",
    version: "v3.6.2",
    size: "约 28 MB",
    requirement: "Android 8.0 及以上",
    points: [
      "在官网入口的「下载」板块选择安卓安装包。",
      "下载完成后如提示「未知来源」，在系统设置中允许本次安装即可。",
      "安装后首次打开请授予存储与网络权限，用于缓存与播放。",
      "更新新版本时可直接覆盖安装，登录进度不会丢失。",
    ],
  },
  {
    key: "ios",
    label: "iOS 苹果",
    icon: "ri-apple-line",
    version: "v3.6.0",
    size: "约 92 MB",
    requirement: "iOS 13.0 及以上",
    points: [
      "用 Safari 打开官网入口，进入 iOS 下载说明页。",
      "按页面指引完成描述文件或企业签名安装。",
      "若提示「未受信任」，前往「设置 - 通用 - VPN 与设备管理」中信任一次。",
      "建议把官网入口加入主屏幕书签，方便更新与重新安装。",
    ],
  },
  {
    key: "desktop",
    label: "电脑 桌面版",
    icon: "ri-computer-line",
    version: "网页版",
    size: "无需安装",
    requirement: "Chrome / Edge 最新版",
    points: [
      "电脑上无需安装客户端，直接用浏览器打开官网入口即可观看。",
      "建议使用 Chrome 或 Edge，并开启硬件加速以获得更流畅的播放。",
      "可把网页入口固定到浏览器书签栏，一键直达。",
      "如需更大屏幕体验，按 F11 进入全屏模式即可。",
    ],
  },
];

export const channels = [
  {
    key: "series",
    label: "影视剧集",
    icon: "ri-movie-2-line",
    title: "影视剧集",
    desc: "按剧集、季数与更新进度整理，涵盖都市、悬疑、古装等常见类型，支持追剧与连播。",
    tags: ["都市情感", "悬疑推理", "古装传奇", "科幻奇幻", "犯罪刑侦"],
    meta: "分类索引 · 按更新与热度排序",
  },
  {
    key: "short",
    label: "短视频",
    icon: "ri-play-circle-line",
    title: "短视频",
    desc: "竖屏短视频流，上下滑动切换，涵盖生活、搞笑、才艺与创意剪辑等日常内容。",
    tags: ["生活日常", "轻松搞笑", "才艺表演", "创意剪辑", "旅行见闻"],
    meta: "竖屏流 · 连续滑动播放",
  },
  {
    key: "anime",
    label: "动漫番剧",
    icon: "ri-magic-line",
    title: "动漫番剧",
    desc: "新番与经典动漫按季度归档，标注更新集数与连载状态，方便按番剧跟进。",
    tags: ["热血少年", "日常治愈", "恋爱青春", "科幻机甲", "国漫专区"],
    meta: "按季度归档 · 标注连载状态",
  },
  {
    key: "doc",
    label: "纪录片",
    icon: "ri-earth-line",
    title: "纪录片",
    desc: "自然、人文、历史与科技主题纪录片合集，画质清晰，适合慢节奏沉浸观看。",
    tags: ["自然生态", "历史人文", "科技探索", "美食记录", "社会观察"],
    meta: "高清画质 · 分主题合集",
  },
  {
    key: "variety",
    label: "综艺娱乐",
    icon: "ri-mic-line",
    title: "综艺娱乐",
    desc: "真人秀、脱口秀与音乐类节目按月更新，按节目名称与期数整理。",
    tags: ["真人秀", "脱口秀", "音乐现场", "访谈对话", "竞技比赛"],
    meta: "按节目分期 · 每月更新",
  },
  {
    key: "live",
    label: "直播专区",
    icon: "ri-live-line",
    title: "直播专区",
    desc: "聚合开播中的房间，按人气与分类展示，进入直播间可查看实时状态。",
    tags: ["人气推荐", "才艺表演", "聊天互动", "游戏竞技", "音乐电台"],
    meta: "实时状态 · 按人气排序",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "确认可用入口",
    desc: "先在本页「最新地址」分区查看当前可用线路，选择状态为推荐或可用的入口打开。",
  },
  {
    step: "02",
    title: "识别官方页面",
    desc: "官方入口排版规整、无强制弹窗、不索要银行卡等敏感信息。若页面异常跳转，请立刻关闭并回到本页。",
  },
  {
    step: "03",
    title: "按需下载 App",
    desc: "想要更流畅的观看体验，可到「App下载」分区按手机系统选择对应版本，参考安装步骤完成。",
  },
  {
    step: "04",
    title: "收藏防走失",
    desc: "把本页加入收藏夹并同步到多个设备。之后无论地址如何变化，都能从这里找回最新入口。",
  },
];

export const safetyTips = [
  {
    icon: "ri-alert-line",
    title: "警惕山寨入口",
    desc: "搜索结果中常见仿冒站点，页面相似但会诱导下载来路不明的程序。请只从本页核对过的入口进入。",
  },
  {
    icon: "ri-lock-password-line",
    title: "保护账号与密码",
    desc: "任何页面若要求输入银行卡号、支付密码或验证码，都应立即停止操作，官方不会索取此类信息。",
  },
  {
    icon: "ri-download-2-line",
    title: "只装正规安装包",
    desc: "安卓安装包请从官方入口下载，不要安装第三方渠道修改过的版本，以免夹带多余程序。",
  },
  {
    icon: "ri-wifi-off-line",
    title: "公共网络需谨慎",
    desc: "在公共 Wi-Fi 下尽量避免登录账号或进行需要隐私的操作，改用手机流量更稳妥。",
  },
];

export const faqs = [
  {
    q: "为什么昨天的网址今天打不开了？",
    a: "域名会因线路维护、网络环境等原因变化，旧地址失效属于常见情况。此时无需慌张，回到本页查看「最新地址」分区即可获取当下可用的入口，这正是本站长期保留的意义。",
  },
  {
    q: "本页的地址会一直有效吗？",
    a: "本页作为入口指引页会持续维护，地址栏目也会随实际可用情况更新。建议把本页收藏，并额外保存到邮箱或聊天记录中，做到多重备份。",
  },
  {
    q: "安卓手机安装时提示「未知来源」怎么办？",
    a: "这是系统对非应用商店安装包的安全提醒。进入手机「设置 - 安全 - 安装未知应用」，允许浏览器安装一次即可，安装完成后可再关闭该权限。",
  },
  {
    q: "iOS 安装后提示「未受信任」怎么处理？",
    a: "打开「设置 - 通用 - VPN 与设备管理」，找到对应的描述文件并选择「信任」，之后即可正常打开。如果仍无法使用，回到本页重新按 iOS 说明获取最新安装方式。",
  },
  {
    q: "电脑上一定要安装客户端吗？",
    a: "不必须。电脑端直接用 Chrome 或 Edge 等现代浏览器打开官网入口即可观看，无需安装任何客户端，也便于通过书签一键直达。",
  },
  {
    q: "如何分辨真实入口和假冒网址？",
    a: "官方入口排版整洁、无强制跳转、不会索要支付信息。遇到满屏广告、要求输入银行卡或验证码、诱导下载未知程序的页面，请立即关闭，并回到本页重新获取入口。",
  },
  {
    q: "换手机或重装系统后还能找回吗？",
    a: "可以。只要你曾把本页保存到邮箱、云笔记或账号收藏中，换设备后仍能打开本页，再按「最新地址」与「App下载」分区操作即可。",
  },
  {
    q: "为什么不同网络下能打开的情况不一样？",
    a: "不同运营商与网络环境对线路的解析速度不同，同一地址可能在某些网络下暂时不通。可尝试切换 Wi-Fi 与流量，或选用备用线路后再访问。",
  },
];

export const collectionTips = [
  "把本页加入浏览器收藏夹，并开启云同步，换设备也能一键找回。",
  "将本页链接发送到自己的邮箱或聊天窗口，作为第二份备份。",
  "在手机主屏幕添加书签，遇到地址失效时可快速打开。",
  "记住本站名称「樱桃视频」，搜索时优先核对页面是否为本文所述的官方入口。",
];